<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="50%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div class="col-12 col-md-4">
            <fg-input
              type="text"
              :label="`${$t('common_words.code')}: *`"
              v-model="model.code"
              v-validate="modelValidations.code"
              name="common_words.code"
              :error="getError('common_words.code', true)"
              @click="handleClickOnCode('prining.pruning_method')"
            >
            </fg-input>
          </div>
          <div class="col-12 col-md-8">
            <fg-input
              type="text"
              :label="`${$t('common_words.name')}: *`"
              v-model="model.name"
              v-validate="modelValidations.name"
              name="common_words.name"
              :error="getError('common_words.name')"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group has-label">
              <label>{{ $t('common_words.description') }}:</label>
              <br />
              <el-input
                maxlength="300"
                show-word-limit
                class="shadow-sm"
                type="textarea"
                :rows="3"
                placeholder="..."
                v-model="model.description"
              ></el-input>
              <br />
            </div>
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-create',
  mixins: [MixinDialog, MixinForm, MixinValidations],
  data() {
    return {
      disabledField: false,
      model: {
        code: null,
        name: null,
        description: null,
      },
      modelValidations: {
        code: { required: true },
        name: { required: true },
      },
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    updateDisabledField(value) {
      this.disabledField = value;
    },
    /**
     * Método para validar un formulario de edición o guardado
     */
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit('addEdit', this.model);
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      sessionStorage.removeItem('editForm');
      this.model = {
        ...editForm,
        isEdit: true,
      };
    }
  },
};
</script>
